import React from 'react';
import styled from 'styled-components';

const FlipContainer = styled.div`
  width: 100%;
  height: 120px;
  perspective: 1000px;
`;

const FlipInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  
  ${FlipContainer}:hover & {
    transform: ${({ hasRevenue }) => hasRevenue ? 'rotateY(180deg)' : 'none'};
  }
`;

const CardSide = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
`;

const FrontSide = styled(CardSide)`
  background-color: ${({ isHighlighted }) => isHighlighted ? '#fff3cd' : 'white'};
  border: 1px solid ${({ isHighlighted }) => isHighlighted ? '#ffeaa7' : '#e8e8e8'};
  border-radius: 12px;
  box-shadow: ${({ isHighlighted }) => isHighlighted ? '0 4px 12px rgba(255, 193, 7, 0.3)' : '0 2px 6px rgba(0, 0, 0, 0.08)'};
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: ${({ clickable }) => clickable ? 'pointer' : 'default'};
`;

const BackSide = styled(CardSide)`
  background: linear-gradient(135deg, ${({ color }) => color || '#1890ff'}, ${({ color }) => color || '#1890ff'}dd);
  border-radius: 12px;
  transform: rotateY(180deg);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  color: white;
`;

const Title = styled.h4`
  font-size: 14px;
  color: ${({ color }) => color || "#333"};
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-weight: 600;
`;

const Value = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: ${({ isHighlighted }) => isHighlighted ? '#856404' : '#333'};
  text-align: center;
  margin: 8px 0;
`;

const RevenueTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
`;

const RevenueValue = styled.div`
  font-size: 18px;
  font-weight: bold;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;

const FlipCard = ({ 
  item, 
  revenue, 
  isHighlighted, 
  onClick, 
  showTrend,
  children 
}) => {
  const hasRevenue = revenue && revenue > 0;
  
  const formatRevenue = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
    }).format(value);
  };

  return (
    <FlipContainer onClick={onClick}>
      <FlipInner hasRevenue={hasRevenue}>
        <FrontSide 
          isHighlighted={isHighlighted} 
          clickable={item.done > 0}
        >
          <Title color={item.color}>
            {item.title}
            {item.icon}
          </Title>
          <Value isHighlighted={isHighlighted}>{item.done}</Value>
          {showTrend && (item.trendIcon || item.trendText) && (
            <div style={{ 
              fontSize: '10px', 
              fontWeight: '600',
              marginTop: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '4px'
            }}>
              {item.trendText && (
                <span style={{ color: (item.trendIcon && item.trendIcon.props && item.trendIcon.props.style && item.trendIcon.props.style.color) || '#6c757d' }}>
                  {item.trendText}
                </span>
              )}
              {item.trendIcon}
            </div>
          )}
        </FrontSide>
        
        {hasRevenue && (
          <BackSide color={item.color}>
            <RevenueTitle>Receita</RevenueTitle>
            <RevenueValue>{formatRevenue(revenue)}</RevenueValue>
          </BackSide>
        )}
      </FlipInner>
    </FlipContainer>
  );
};

export default FlipCard;